var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg18IcBlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9,2 C5.136,2 2,5.136 2,9 C2,12.864 5.136,16 9,16 C12.864,16 16,12.864 16,9 C16,5.136 12.864,2 9,2 Z M3.4,9 C3.4,5.906 5.906,3.4 9,3.4 C10.295,3.4 11.485,3.841 12.43,4.583 L4.583,12.43 C3.841,11.485 3.4,10.295 3.4,9 Z M9,14.6 C7.705,14.6 6.515,14.159 5.57,13.417 L13.417,5.57 C14.159,6.515 14.6,7.705 14.6,9 C14.6,12.094 12.094,14.6 9,14.6 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg18IcBlock);
export default __webpack_public_path__ + "static/media/18_ic_block.3157bc93.svg";
export { ForwardRef as ReactComponent };